import { render, staticRenderFns } from "./AccountConfigSecurity.vue?vue&type=template&id=b6d59f7a"
import script from "./AccountConfigSecurity.vue?vue&type=script&lang=js"
export * from "./AccountConfigSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports